import {withSentryErrorBoundary} from '@wix/native-components-infra/dist/es/src/HOC/sentryErrorBoundary/sentryErrorBoundary';
import {AddToCartApp} from './AddToCartApp';
import {bootstrapApp} from '../../commons/bootstrap';
import {ADD_TO_CART_DSN} from '@wix/wixstores-client-storefront-sdk/dist/es/src/viewer-script/sentryConf';
import {withLeanStyles} from '@wix/native-components-infra/dist/es/src/HOC/withStyles/withLeanStyles';

export const component = withSentryErrorBoundary(bootstrapApp(AddToCartApp, withLeanStyles), {
  dsn: ADD_TO_CART_DSN,
  config: {environment: 'Native Component'},
});
